/* eslint-disable no-case-declarations */
import { ColumnDirective, ColumnsDirective, CommandColumn, Edit, GridComponent, Inject, Sort, Toolbar } from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { DeleteAPIData, LoadAPIData, SaveAPIData } from '../helpers/DataHelper';
import { CommandTemplate, SearchGridToolbar, ConfirmDialogStyles } from '../helpers/global';
import { confirm } from "react-confirm-box";
import { ShowToast } from '../helpers/Toast';
import { fieldRequired } from '../helpers/validation';
import moment from 'moment';

export default function Contacts() {

  const [editData, setEditData] = useState();
  const [editId, setEditId] = useState(0);

  const [brand, setBrand] = useState('');
  const [contact, setContact] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');
  const [dateModified, setDateModified] = useState(new Date());
  const [modifiedByName, setModifiedByName] = useState('');
  const [editModal, setEditModal] = useState(false);

  const toggle = () => setEditModal(!editModal);


  const commandClick = async (args) => {
    switch (args.commandColumn.type) {
      case 'Delete':
        if (await confirm("Are you sure you want to delete this contact?", ConfirmDialogStyles)) {
          deleteItem(args.rowData.id);
        }
        break;
      default: //edit
        editItem(args.rowData.id);
        break;
    }
  }

  const loadData = async () => {
    const data = await LoadAPIData('/api/contacts')
    //console.log(data);
    setEditData(data);
  }

  const addItem = () => { editItem(0); }

  const editItem = (id) => {
    if (id > 0) {
      const data = editData.find((item) => { return item.id === id });
      setEditId(data.id);

      setBrand(data.brand);
      setContact(data.contact);
      setRole(data.role);
      setEmail(data.email);
      setTelephone(data.telephone);
      setDateModified(data.dateModified);
      setModifiedByName(data.modifiedByName);
    }
    else {
      //clear state fields
      setEditId(0);

      setBrand('');
      setContact('');
      setRole('');
      setEmail('');
      setTelephone('');
      setDateModified(null);
      setModifiedByName('');
    }
    setEditModal(true);
  };

  const validateForm = () => {
    var valid = true;
    valid &= fieldRequired(brand, 'tbBrandError', '* required');
    valid &= fieldRequired(contact, 'tbContactError', '* required');
    valid &= fieldRequired(email, 'tbEmailError', '* required');
    valid &= fieldRequired(telephone, 'tbTelephoneError', '* required');

    return valid;
  }

  const saveItem = async (event) => {
    event.stopPropagation();

    if (validateForm()) {
      const data = { id: editId, brand: brand, contact: contact, role: role, email: email, telephone: telephone };
      //console.log(data);
      const result = await SaveAPIData('/api/contacts', data, (editId === 0 ? 'POST' : 'PUT'));
      if (result.success) {
        loadData();
        ShowToast('Contacts', 'The contacts was successfully saved!', 'toast-success');
      }
      else {
        ShowToast('Contacts', 'There was an error saving the contacts!', 'toast-danger');
      }
      toggle();
    }
  }

  const deleteItem = async (dataId) => {
    const result = await DeleteAPIData('/api/contacts/' + dataId)
    if (result) {
      loadData();
      ShowToast('Contacts', 'The contact was successfully deleted!', 'toast-success');
    }
    else {
      ShowToast('Contacts', 'There was an error deleting the contact!', 'toast-danger');
    }
  }


  useEffect(() => {
    loadData();
  }, []);

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const emailTemplate = ((props: any) => {
    //console.log(props);
    if (isValidEmail(props.email))
      return <a href={`mailto:${props.email}`}>{props.email}</a>
    else
      return props.email;
  })

  return (
    <>
      <div className="row">
        <div className="col-md-6 "><h1>Contacts</h1></div>
        <div className="col-md-6 text-end align-self-center">
          <Button color="primary" size="sm" onClick={addItem}>Add New <i className="fas fa-plus-circle ms-2"></i></Button>
        </div>
      </div>

      <GridComponent dataSource={editData} allowSorting={true} toolbar={SearchGridToolbar} commandClick={commandClick} >
        <ColumnsDirective>
          <ColumnDirective field='Brand' width='100' headerText="Brand" />
          <ColumnDirective field='Contact' width='100' headerText="Contact" />
          <ColumnDirective field='Role' width='70' headerText="Role" />
          <ColumnDirective field='Email' width='100' headerText="Email" template={emailTemplate} />
          <ColumnDirective field='Telephone' width='50' headerText="Telephone" />
          <ColumnDirective headerText='Actions' width='50' commands={CommandTemplate} />
        </ColumnsDirective>
        <Inject services={[Sort, Edit, CommandColumn, Toolbar]} />
      </GridComponent>

      <Modal isOpen={editModal} toggle={toggle} scrollable size="lg" backdrop="static">
        <ModalHeader toggle={toggle}>{editId === 0 ? "Add New" : "Edit"} Contact</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className='mb-3 col-md-6'>
              <TextBoxComponent id='tbBrand' name='tbBrand' placeholder='Brand' type='text' maxLength='350' floatLabelType='Auto' showClearButton={true} value={brand} onChange={e => setBrand(e.value)} />
              <div id='tbBrandError' className='error-message' />
            </div>

            <div className='mb-3 col-md-6'>
              <TextBoxComponent id='tbContact' name='tbContact' placeholder='Contact' type='text' maxLength='350' floatLabelType='Auto' showClearButton={true} value={contact} onChange={e => setContact(e.value)} />
              <div id='tbContactError' className='error-message' />
            </div>

            <div className='mb-3 col-md-4'>
              <TextBoxComponent id='tbRole' name='tbRole' placeholder='Role' type='text' maxLength='350' floatLabelType='Auto' showClearButton={true} value={role} onChange={e => setRole(e.value)} />
              <div id='tbRoleError' className='error-message' />
            </div>

            <div className='mb-3 col-md-5'>
              <TextBoxComponent id='tbEmail' name='tbEmail' placeholder='Email' type='text' maxLength='750' floatLabelType='Auto' showClearButton={true} value={email} onChange={e => setEmail(e.value)} />
              <div id='tbEmailError' className='error-message' />
            </div>

            <div className='mb-3 col-md-3'>
              <TextBoxComponent id='tbTelephone' name='tbTelephone' placeholder='Telephone' type='text' maxLength='250' floatLabelType='Auto' showClearButton={true} value={telephone} onChange={e => setTelephone(e.value)} />
              <div id='tbTelephoneError' className='error-message' />
            </div>

          </div>
          <small className="text-muted"><i>
            {modifiedByName ? ("Last modified by " + modifiedByName) + " on " + moment(dateModified).format('MMMM Do YYYY, h:mm:ss a') : ""}
          </i>
          </small>
        </ModalBody>
        <ModalFooter>
          <Button color="dark" size="sm" onClick={toggle}>Cancel <i className="far fa-times-circle ms-2"></i></Button>
          <Button color="success" size="sm" onClick={saveItem}>Save <i className="far fa-check-circle ms-2"></i></Button>
        </ModalFooter>
      </Modal>

    </>
  );
}

